import { ApolloClient, from, gql, NormalizedCacheObject } from '@apollo/client';
import { getCache } from './Cache';
import { authLink } from './AuthLink';
import { errorLink } from './ErrorLink';
import { terminatingLink } from './terminatingLink';
import ApolloLinkTimeout from 'apollo-link-timeout';

const timeoutLink = new ApolloLinkTimeout(30000); // default timeout for queries

// For Apollo Client devtools. @see https://www.apollographql.com/docs/react/local-state/client-side-schema/
const typeDefs = gql`
  extend type Query {
    isLoggedIn: Boolean
    selectedWorkspaceId: String
  }
`;

let apolloClient: ApolloClient<NormalizedCacheObject>;
export const _getApolloClient = () => {
  apolloClient =
    apolloClient ||
    new ApolloClient({
      link: from([errorLink, authLink, timeoutLink, terminatingLink]),
      cache: getCache(),
      typeDefs
    });

  return apolloClient;
};

export const _resetApolloClient = () => {
  apolloClient = new ApolloClient({
    link: from([errorLink, authLink, timeoutLink, terminatingLink]),
    cache: getCache(),
    typeDefs
  });
  return apolloClient.clearStore();
};
